import { useMutation } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { inviteRepresentativeToSign } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';

export const useInviteRepresentative = () => {
	return useMutation({
		mutationKey: [
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_INVITE_REPRESENTATIVE_POST,
		],
		mutationFn: inviteRepresentativeToSign,
	});
};
